"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var jquery_1 = __importDefault(require("jquery"));
var Widget_1 = require("../tools/Widget");
var Accordion = (function (_super) {
    __extends(Accordion, _super);
    function Accordion(node, config) {
        var _this = _super.call(this, node, config) || this;
        (0, jquery_1.default)(_this.el).on('click', function () {
            (0, jquery_1.default)(this).toggleClass('active');
            (0, jquery_1.default)('[data-accordion-content="' + (0, jquery_1.default)(this).attr('data-accordion-tab') + '"]').slideToggle(400);
        });
        return _this;
    }
    return Accordion;
}(Widget_1.Widget));
exports.Accordion = Accordion;
